import { createFileRoute } from '@tanstack/react-router';

import { WorkReviewsPage } from '@/features/me/talent-pages';

export const Route = createFileRoute('/_app/me/work/reviews')({ component: WorkReviewsPage });
